import { Widget } from 'models/widgetMultiStageOlympiad';
import React, { useContext } from 'react';

export interface WidgetList extends Widget {
  showForMunicipality: boolean;
  showForRegion: boolean;
}

export interface ConfiguratorsContextProps {
  loaded: boolean;
}

const defaultContext: ConfiguratorsContextProps = {
  loaded: false,
};

const Context = React.createContext<ConfiguratorsContextProps>(defaultContext);

const ConfiguratorsContext = (props: React.PropsWithChildren<{}>) => {

  return (
    <Context.Provider
      value={{
        loaded: true,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export const useConfiguratorsContext = () => useContext(Context);

export default ConfiguratorsContext;

